import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { 
    getQuestion, putResponse, updateHeaderInfo, 
    getQuestionResults, addQuestionToDeck, putNextReviewDate, 
    addNote, getUserDetails, removeQuestion 
} from "../actions";
import { QuestionCard, CopyrightWidget, LoadingCard } from "../components";
import "../styles/questionStyles.css";
import { deviceData, scrollTop, preventCopy, alertNotification, getThisYear } from "../common";

class QuestionScreen extends React.Component {
    state = {
        answerChoice: -1,
        next: false,
        backgroundColor: "#00567a",
        loading: true, 
        prevID: null,
        nextID: null,
        questionid: null,
        startNext: false,
        refsMats: null,
        yend: getThisYear(),
        ybegin: 2012,
    };

    redirectPage = (from = 'undefined') => {
        switch (Number(this.props.question.gameMode)) {
            case 1:
            case 2: {
                return this.props.history.push('/testResultScreen');
            }

            case 3:
            case 4: {
                return this.props.history.push('/myDecks');
            }

            default: {
                return this.props.history.push('/home');
            }
        }
    }

    scrollToTop = () => {
        return scrollTop('questionDIV', 0);
    }

    componentDidMount = async () => {
        preventCopy();

        console.log(this.props.location);

        const { mcid, key } = this.props.auth_feedback;
        const { testYear, gameMode, deckID } = this.props.location;
        let questionData;
        let type;

        const page = deviceData(this.props.location, 'navigate');

        await this.props.getUserDetails(mcid, key, page);

        scrollTop('questionDIV', 0);
        
        if (gameMode === 2 || gameMode === 1) {
            questionData = {
                yearvar: testYear,
                mcid: mcid,
                key: key,
                gamemode: gameMode,
                tracking: {
                    action: 'get test question',
                    os: page.os,
                    ua: page.ua,
                    pathname: page.pathname,
                    pagevia: page.pagevia
                }
            };
            type = 'test';
        } else if (gameMode === 3 || gameMode === 4 || gameMode === 7) {
            questionData = {
                mcid: mcid,
                key: key,
                gamemode: gameMode,
                deckID: deckID,
                tracking: {
                    action: 'get deck question',
                    os: page.os,
                    ua: page.ua,
                    pathname: page.pathname,
                    pagevia: page.pagevia
                }
            };
            type = 'deck';
        }

        await this.props.getQuestion(questionData, type);

        document.addEventListener('keydown', this.onKeyDown);

        return this.setState({ 
            ...this.state, 
            backgroundColor: this.getHeaderColor(), 
            prevID: null, 
            nextID: null, 
            loading: true 
        });
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.serverMsg !== this.props.serverMsg) {
            await alertNotification({
                message: this.props.serverMsg.message,
                title: 'SASP Notification',
                buttonName: 'OK'
            });

            return this.openBookNav();
            // return this.skipQuestion(this.props.question.nextQuestionID);
        }

        if (prevProps.question !== this.props.question) {
            this.scrollToTop();

            if (!Array.isArray(this.props.question) && typeof this.props.question === 'object') {
                if (
                    typeof this.props.question.error !== 'undefined' || 
                    this.props.question.questionID === '' ||
                    !Number(this.props.question.morequestions)
                ) {
                    return this.redirectPage('componentDidUpdate');
                } else {
                    let prevID = this.props.question.previousQuestionID;
                    let nextID = this.props.question.nextQuestionID;

                    if (
                        typeof prevProps.question.questionID !== 'undefined' 
                        && this.props.location.gameMode > 2
                        && prevState.nextID != this.props.question.questionID
                        && prevState.nextID != null
                    ) {
                        nextID = prevProps.question.questionID;
                    }
                    
                    this.setState({
                        ...this.state,
                        prevID: prevID,
                        nextID: nextID,
                        loading: false, 
                        questionid: this.props.question.questionID,
                    });
                }
            } else {
                return this.redirectPage('error');
            }   
        }

        if (prevState.answerChoice !== this.state.answerChoice) {
            let putResponseData = {
                mcid: prevProps.auth_feedback.mcid,
                key: prevProps.auth_feedback.key,
                questionID: prevProps.question.questionID,
                gamemode: prevProps.question.gameMode,
                optionSelected: this.state.answerChoice,
                deckID: this.props.location.deckID,
                tracking: deviceData(this.props.location, 'submit answer')
            };
            await this.props.putResponse(putResponseData);
            
            if (prevProps.question.gameMode === 2 || prevProps.question.gameMode === 4) {
                let questionData = {
                    yearvar: prevProps.location.testYear,
                    mcid: prevProps.auth_feedback.mcid,
                    key: prevProps.auth_feedback.key,
                    gamemode: prevProps.question.gameMode,
                    areavar: ""
                };

                questionData.tracking = deviceData(this.props.location, 'get question');
                await this.props.getQuestion(questionData);
            }
        }

        if (prevState.next !== this.state.next) {
            if (Number(prevProps.question.gameMode) === 1 || Number(prevProps.question.gameMode === 2)) {
                let questionData = {
                    yearvar: prevProps.location.testYear,
                    mcid: prevProps.auth_feedback.mcid,
                    key: prevProps.auth_feedback.key,
                    gamemode: prevProps.question.gameMode,
                    areavar: "",
                    deckID: prevProps.location.deckID,
                };

                if (typeof prevProps.question.questionID !== 'undefined') {
                    questionData.previousQuestionID = prevProps.question.questionID;
                }

                questionData.tracking = deviceData(this.props.location, 'get question');
                await this.props.getQuestion(questionData);
                document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
            }
        
            if (Number(prevProps.question.gameMode) === 3 || Number(prevProps.question.gameMode) === 4 || prevProps.question.gameMode === 7) {
                let questionData = {
                    yearvar: "",
                    mcid: prevProps.auth_feedback.mcid,
                    key: prevProps.auth_feedback.key,
                    gamemode: prevProps.location.gameMode,
                    areavar: "",
                    deckID: prevProps.location.deckID
                };

                if (typeof prevProps.question.questionID !== 'undefined') {
                    questionData.previousQuestionID = prevProps.question.questionID;
                }

                questionData.tracking = deviceData(this.props.location, 'get question');

                await this.props.getQuestion(questionData);
                document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
            }

            this.setState({ ...this.state });
        }
        
        return this.props.updateHeaderInfo({
            route:"/questionScreen", 
            name: this.setHeaderName(), 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: this.state.backgroundColor
        });
    };

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyDown = (event) => {
        const pressedKey = String.fromCharCode(event.keyCode).toLowerCase();

        if (event.ctrlKey && pressedKey === "c") {
            event.returnValue = false;
        }
    }

    getHeaderColor = () => {
        let r;
        switch(Number(this.props.location.testYear)) {
            case 2020: {
                r = '#B2C7E3'; break;
            }
            case 2019: {
                r = '#97A19C'; break;
            }
            case 2018: {
                r = '#7A8D96'; break;
            }
            case 2017: {
                r = '#62B5E5'; break;
            }
            case 2016: {
                r = '#A8AA89'; break;
            }
            case 2015: {
                r = '#A99D8C'; break;
            }
            case 2014: {
                r = '#8ebe74'; break;
            }
            case 2013: {
                r = '#8CA1AD'; break;
                //wrong answers
            }
            case 2012: {
                r = '#A5A5A5'; break;
                //prostate cancer color
            }

            default: {
                r = '#00567a';
                break;
            }
        }

        return r;
    }

    setHeaderName = () => {
        let r = 'temp name';

        switch(this.props.location.gameMode) {
            case 1:
            case 2: {
                r = "SASP " + this.props.location.testYear;
                break;
            }

            case 3:
            case 4: {
                let temp = this.props.deckList.find(item => item.deckID === this.props.location.deckID);
                r = temp.deckname;
                break;
            }

            default: {
                r = 'sasp';
                break;
            }
        }
        return r;
    }

    updateOption = answer => {
        return this.setState({
            answerChoice: answer
        });
    };

    openBookNav = (bool) => {
        bool = !this.state.next;
        scrollTop('questionDIV', 0);
        return this.setState({
            ...this.state,
            next: bool
        });
    };

    addToDecks = async (id, deckID) => {
        let cnt = 0;
        let obj;
        if (!deckID) {
            for (const i in this.props.deckList) {
                obj = {
                    mcid: this.props.auth_feedback.mcid,
                    key: this.props.auth_feedback.key,
                    questionID: id, 
                    deckID: this.props.deckList[i].deckID
                };

                this.props.addQuestionToDeck(obj);
                cnt++
            }
        } else {
            obj = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                questionID: id, 
                deckID: deckID
            };

            this.props.addQuestionToDeck(obj);
        }
        
    }

    removeQuestion = async(obj) => {
        return this.props.removeQuestion(obj);
    }

    skipQuestion = async (questionID) => {
        const page = deviceData(this.props.location, 'skip question');

        let data = {
            yearvar: this.props.question.QuestionYear,
            mcid: this.props.auth_feedback.mcid,
            key: this.props.auth_feedback.key,
            gamemode: this.props.location.gameMode,
            areavar: this.props.question.areaVar,
            deckID: (this.props.location.deckID ? this.props.location.deckID : null),
            questionID: questionID,
            tracking: {
                action: 'skip question',
                os: page.os,
                ua: page.ua,
                pathname: page.pathname,
                pagevia: page.pagevia
            }
        };

        this.scrollToTop();
        await this.setState({ ...this.state, answerChoice: -1, loading: true });

        this.props.getQuestion(data);        
    }

    addNote = async (data) => {
        data.questionID = Number(data.questionID);

        data.tracking = this.state.tracking;
        this.props.addNote(data);
    }

    resetTest = () => {
    };
    
    //TODO fix minHeight. needs to be adjusted or at the very least put in a stylesheet
    //and calculated based on media queries. good for upcoming demo only

    render () {
        const { question } = this.props;

        if (typeof question === 'object' && !Array.isArray(question)) {        
            if (!Number(question.morequestions)) {
                return null; 
            } else {
                return (
                    <div 
                        style={
                            { 
                                position: 'relative',
                                marginBottom: '64px'
                            }
                        }
                        className="height100 aua-overflow"
                        id="questionDIV"
                    >
                        <QuestionCard
                            myKey={this.props.user_details.key}
                            gameMode={this.props.location.gameMode}
                            updateOption={this.updateOption}
                            answers={this.props.question.qoptions}
                            question={this.props.question}
                            goNext={this.openBookNav}
                            explanation={this.props.sessionAnsweredQuestion}
                            deckID={this.props.location.deckID ? this.props.location.deckID : 1}
                            prevID={this.state.prevID}
                            nextID={this.state.nextID}
                            cardColor={this.state.backgroundColor}
                            deckList={this.props.deckList ? this.props.deckList : []}
                            skipQuestion={this.skipQuestion}
                            deckText={this.props.question.QuestionYear + " Question " + this.props.question.questionNumber}
                            putNextReviewDate={this.props.putNextReviewDate}
                            addNote={this.addNote}
                            addToDecks={this.addToDecks}
                            removeQuestion={this.removeQuestion}
                            scrollToTop={this.scrollToTop}
                            refsMats={this.state.refsMats}
                            labs={this.props.user_details.labstest}
                        />

                        <CopyrightWidget 
                            begin={this.state.ybegin}
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-48 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                ); 
            }
        } else {
            return (
                <LoadingCard />
            );
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { question, sessionAnsweredQuestion } = state.question;
    const { deckList, serverMsg } = state.decks;

    return {
        question,
        user_details,
        sessionAnsweredQuestion,
        auth_feedback,
        deckList,
        serverMsg
    };
};

export default connect(mapStateToProps, 
    { putResponse, getQuestion, getQuestionResults, addQuestionToDeck, updateHeaderInfo, putNextReviewDate, addNote,getUserDetails, removeQuestion }
)( withRouter(QuestionScreen));

//TODO find where question list coming from/how to pull the flow correctly
//into reducers and then into here
//TODO walk through backend flow with pat in more detail on this.
